export enum AppEvents {
  LeavePage = 'LeavePage',
  ChangedPage = 'ChangedPage'
}
